import axios from "axios";
import { GetPackageRequest, GetPackageResponse } from "@capone/packages-api";
import { config } from "../../config";

import { getPackageApiPath } from "../paths";

export const getPackage = (
  body: GetPackageRequest
): Promise<GetPackageResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(getPackageApiPath, body, {
        baseURL: config.baseURL,
      });

      if (res.data.Response === "Success") {
        resolve(res.data.value);
      } else {
        reject(res.data.error);
      }
    } catch (e) {
      reject(e);
    }
  });
